import { IScanTMRZAction } from "./types/scanTesseractMrzTypes";

export const initCreateWorker = (): IScanTMRZAction<any> => {
  return {
    type: "INIT_CREATE",
  };
};

export const updateProgress = (progress: number): IScanTMRZAction<any> => {
  return {
    type: "MRZ_PROGRESS",
    payload: progress,
  };
};

export const startScanning = (): IScanTMRZAction<any> => {
  return {
    type: "MRZ_START",
  };
};
export const stopScanning = (): IScanTMRZAction<any> => {
  return {
    type: "MRZ_STOP",
  };
};
export const updateTimer = (): IScanTMRZAction<any> => {
  return {
    type: "MRZ_TIMER",
  };
};
